import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useEffect, useState } from 'react';
import lodashIsEqual from 'lodash/isEqual';
export var useMemoizedStateObject = function useMemoizedStateObject(data) {
  var equalityCheck = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : lodashIsEqual;
  var _useState = useState(data),
    _useState2 = _slicedToArray(_useState, 2),
    memoizedData = _useState2[0],
    setMemoizedData = _useState2[1];
  useEffect(function () {
    if (!equalityCheck(data, memoizedData)) {
      setMemoizedData(data);
    }
  }, [data, memoizedData, equalityCheck]);
  return memoizedData;
};